import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useFleetsList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        { key: 'make', label: 'Make', sortable: true },
        { key: 'plateNumber', label: 'Plate number', sortable: true },
        { key: 'cardNumber', label: 'Card number', sortable: true },
        { key: 'isTrailer', label: 'Trailer / Cabin', sortable: true },
        { key: 'transporter', label: 'Transporter', sortable: true },
        'actions',
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('make')
    const isSortDirDesc = ref(true)
    const locationFilter = ref(null)
    const locationType = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-fleet/list', {
            query: searchQuery.value,
            per_page: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            console.log(response)
            const { fleets, meta } = response.data

            meta.value = meta

            callback(fleets)
            totalRecords.value = meta.value.total
            from.value = meta.value.from
            to.value = meta.value.to
        })
        .catch((error) => {
            // console.log(error)
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching fleets list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }


    const resolveFleetVariant = status => {
        if (status === 1) return 'Trailer'
        if (status === 0) return 'Cabin'
        return 'warning'
    }


    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        resolveFleetVariant,
        refetch,
    }
}